import { Link } from 'react-router-dom'
import { Locale, TIPI_LOCALE_LABELS, PROVINCE_LABELS } from '../../types'

interface MarkerPopupProps {
  locale: Locale
}

/**
 * Contenuto del popup che appare al click su un marker
 * Mostra info essenziali e link alla scheda completa
 */
export default function MarkerPopup({ locale }: MarkerPopupProps) {
  return (
    <div className="min-w-[200px] max-w-[280px]">
      {/* Immagine (opzionale nel popup) */}
      {locale.fotoPrincipale && (
        <div className="w-full h-24 -mx-3 -mt-3 mb-3 overflow-hidden rounded-t-lg">
          <img
            src={locale.fotoPrincipale}
            alt={locale.nome}
            className="w-full h-full object-cover"
            onError={(e) => {
              (e.target as HTMLImageElement).style.display = 'none'
            }}
          />
        </div>
      )}

      {/* Tipo */}
      <span className="inline-block text-xs bg-gold/20 text-gold px-2 py-0.5 rounded-full mb-2">
        {TIPI_LOCALE_LABELS[locale.tipo]}
      </span>

      {/* Nome */}
      <h3 className="font-bold text-white text-lg leading-tight mb-1">
        {locale.nome}
      </h3>

      {/* Località */}
      <p className="text-sm text-gray-400 mb-2">
        {locale.comune}, {PROVINCE_LABELS[locale.provincia]}
      </p>

      {/* Specialità (prime 2) */}
      {locale.specialita.length > 0 && (
        <p className="text-xs text-gray-500 mb-3">
          {locale.specialita.slice(0, 2).join(' • ')}
          {locale.specialita.length > 2 && ' ...'}
        </p>
      )}

      {/* Fascia prezzo e parcheggio */}
      <div className="flex items-center gap-3 text-xs text-gray-400 mb-3">
        {locale.fasciaPrezzo && (
          <span className="text-gold font-semibold">{locale.fasciaPrezzo}</span>
        )}
        {locale.parcheggioGrande && (
          <span className="flex items-center gap-1 text-green-400">
            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
            </svg>
            Parcheggio 4x4
          </span>
        )}
      </div>

      {/* Bottoni azione */}
      <div className="flex gap-2">
        <Link
          to={`/locale/${locale.slug}`}
          className="flex-1 bg-gold text-night text-center text-sm font-semibold py-2 px-3 rounded-lg hover:bg-gold-light transition-colors"
        >
          Vedi scheda
        </Link>
        <a
          href={`https://www.google.com/maps/dir/?api=1&destination=${locale.latitudine},${locale.longitudine}`}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-10 bg-night border border-gold text-gold rounded-lg hover:bg-gold hover:text-night transition-colors"
          title="Indicazioni"
        >
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 20l-5.447-2.724A1 1 0 013 16.382V5.618a1 1 0 011.447-.894L9 7m0 13l6-3m-6 3V7m6 10l4.553 2.276A1 1 0 0021 18.382V7.618a1 1 0 00-.553-.894L15 4m0 13V4m0 0L9 7" />
          </svg>
        </a>
      </div>
    </div>
  )
}
